<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}

.v-application .subtitle-1 {
  font-family: "Prompt", sans-serif !important;
}

.text-spacing {
  letter-spacing: 0px !important;
}

.v-application .white {
  border: #ccd0d9 solid 1px !important;
}

.text_div {
  margin-right: 20px;
  color: black;
  font-weight: bold;
}

.width_combo {
  max-width: 300px;
}

#map-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.pac-target-input {
  border: #b1b1b1 solid 1px;
  max-width: 450px;
  padding: 5px;
  border-radius: 5px;
  text-indent: 10px;
}
</style>

<template>
  <div>
    <menuBar v-if="showMenu"></menuBar>
    <v-container fluid>
      <v-layout class="d-flex justify-space-between mb-2">
        <div class="text-h4 font-weight-black primary--text text-spacing ml-4" color="blue">
          กรอกข้อมูลเพื่อขอรับบริการ กำจัดมูลฝอยติดเชื้อ
        </div>

        <v-spacer></v-spacer>

        <!-- <v-btn color="white" elevation="0" large class="px-10 mr-4">ยกเลิก</v-btn> -->

        <v-btn color="success" elevation="0" large dark class="mr-4 px-10" @click.prevent="add_customer()">
          <div v-if="showMenu"><v-icon left>mdi-plus</v-icon>ส่งข้อมูล</div>
          <div v-else><v-icon left>mdi-plus</v-icon>เพิ่มข้อมูล</div>
        </v-btn>
      </v-layout>

      <!----  form modal ---------->

      <v-container fluid>
        <v-card>
          <v-form ref="form" :lazy-validation="lazy" class="mx-4">
            <v-row>
              <v-col cols="12" lg="6" class="mt-3">
                <v-row dense>
                  <v-col cols="12" lg="3" class="my-n2">
                    ประเภทผู้ติดต่อ:
                    <v-select prepend-icon="mdi-card-account-details" v-model="CONTACT_TYPE" color="black" outlined
                      dense :items="typeTax" :rules="ru_c_type"></v-select>
                  </v-col>
                  <!-- <v-col cols="12" lg="4" class="my-n2">
                    กลุ่มลูกค้า :
                    <v-combobox
                      v-model="CUSTOMER_GROUP"
                      color="black"
                      :items="groupHosp"
                      outlined
                      dense
                      :rules="ru_c_group"
                      @change="(evt) => Setgroup(evt)"
                    ></v-combobox>
                  </v-col> -->
                  <v-col cols="12" lg="3" class="my-n2">
                    <div>
                      สำนักงานใหญ่/สาขา :
                      <v-select prepend-icon="mdi-home-city" v-model="CUSTOMER_BRANCH" dense outlined :items="offices"
                        :rules="ru_c_branch" @change="(e) => set_Office(e)"></v-select>
                    </div>
                    <div v-if="get_Office == true">
                      <v-text-field prepend-icon="mdi-home-city" v-model="CUSTOMER_BRANCH_NAME" dense label="ระบุสาขา:"
                        outlined></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" class="my-n2">
                    <div v-if="serviceA == 'รพ.ใหญ่'">
                      ประเภทโรงพยาบาล :
                      <v-select prepend-icon="mdi-hospital" v-model="CUSTOMER_TYPE" color="black" outlined dense
                        :items="data_ProductA" @change="(evt) => SetpublicHosp(evt)"></v-select>
                    </div>
                    <div v-if="servicePublic == 'อื่น ๆ'" class="mt-n6">
                      ระบุ:
                      <v-text-field prepend-icon="mdi-hospital" v-model="CUSTOMER_TYPE_OTHER" dense
                        outlined></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="6" class="my-n2">
                    ชื่อสถานพยาบาล/บริษัท :
                    <v-text-field prepend-icon="mdi-home-edit" color="black" outlined dense v-model="ORGANIZATION_NAME"
                      :rules="ru_c_organize_name"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="6" class="my-n2">
                    ชื่อสถานที่รับบริการ :
                    <v-textarea prepend-icon="mdi-home-edit" dense outlined v-model="CUSTOMER_NAME"
                      :rules="ru_c_place_name" rows="1"></v-textarea>
                  </v-col>

                  <v-col cols="12" lg="4" class="my-n2">
                    เลขประจำตัวผู้เสียภาษี :
                    <v-text-field prepend-icon="mdi-id-card" dense outlined v-model="CUSTOMER_TAX_ID"
                      :rules="ru_c_taxid"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    ผู้มีอำนาจรับผิดชอบ :
                    <v-text-field prepend-icon="mdi-account-details" v-model="PROVIDER_NAME" dense outlined
                      :rules="ru_c_owner"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n2">
                    ตำแหน่ง :
                    <v-text-field prepend-icon="mdi-book-account-outline" dense outlined
                      v-model="PROVIDER_POSITION"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="5" class="my-n2">
                    ที่อยู่ :
                    <v-textarea prepend-icon="mdi-home-circle" rows="1" row-height="20" outlined dense color="black"
                      v-model="CUSTOMER_ADDRESS" :rules="ru_c_address"></v-textarea>
                  </v-col>

                  <v-col cols="12" lg="4" class="my-n2">
                    โทรศัพท์ :
                    <v-text-field prepend-icon="mdi-card-account-phone" dense outlined v-model="PROVIDER_PHONE"
                      :rules="ru_c_tele"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-n2">
                    โทรศัพท์มือถือ :
                    <v-text-field prepend-icon="mdi-cellphone" dense outlined v-model="CUSTOMER_PHONE"
                      :rules="ru_c_tele"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n4">
                    facebook :
                    <v-text-field prepend-icon="mdi-facebook" dense outlined v-model="PROVIDER_FACEBOOK"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="4" class="my-n4">
                    อีเมล์ :
                    <v-text-field prepend-icon="mdi-email" dense outlined v-model="PROVIDER_EMAIL"
                      :rules="ru_c_email"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n4">
                    line id :
                    <v-text-field prepend-icon="mdi-wechat" dense outlined v-model="PROVIDER_LINE_ID"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n4">
                    <addressinput-subdistrict v-model="CUSTOMER_SUBDISTRICT" />
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n4">
                    <addressinput-district v-model="CUSTOMER_DISTRICT" />
                  </v-col>

                  <v-col cols="12" lg="4" class="my-n4">
                    <addressinput-province v-model="CUSTOMER_PROVINCE" />
                  </v-col>
                  <v-col cols="12" lg="4" class="mt-2">
                    <addressinput-zipcode v-model="CUSTOMER_ZIPCODE" />
                  </v-col>
                  <v-col cols="12" lg="8" class="mt-4">
                    รูปสถานประกอบการ :
                    <FileUpload ref="Use_Method_FileUpload"></FileUpload>
                  </v-col>
                  <v-col cols="12" lg="4" class="my-n5">
                  </v-col>
                  <v-col cols="12" lg="8" class="my-n5">
                    เอกสารบริษัท :
                    <DocFileUpload ref="Use_Method_FileUpload_Document"></DocFileUpload>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-n3 pb-5">
                    <v-checkbox label="ภาษีมูลค่าเพิ่ม" v-model="vat7"
                      @change="(evt) => checked_vat7(evt)"></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-n3 pb-5">
                    <v-select v-if="isVat7" dense :items="se_vat7" style="width: 80px" class="mt-2 ml-2"
                      v-model="vat7_value"></v-select>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-n3 pb-5">
                    <v-checkbox label="หักภาษี ณ ที่จ่าย" v-model="vat3"
                      @change="(evt) => checked_vat3(evt)"></v-checkbox>
                  </v-col>
                  <v-col cols="12" lg="3" class="my-n3 pb-5">
                    <v-select v-if="isVat3" dense :items="se_vat3" style="width: 80px" class="mt-2 ml-2"
                      v-model="vat3_value"></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="6">
                <Day ref="Use_Methods_Day" :fromPage="'regsiter_cus'" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="12" class="mt-n5">
                ตำแหน่งบนแผนที่ :

                <div class="mt-5" style="height: 400px;z-index: -1;">
                  <l-map @click="addMarker" :zoom="zoom" :center="center" style="height: 80%; width: 100%" ref="myMap">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                    <l-marker :lat-lng="markerLatLng"></l-marker>
                    <l-control style="min-width: 1000px;" position="topright">
                      <div style="display: flex;">
                        <div style="width:100%">
                          <v-combobox item-value="display_name" @change="(evt) => searchLocationAndAddMarker(evt)"
                            item-text="display_name" :items="searchLocations" v-model="textsearch" solo
                            dense></v-combobox>
                        </div>
                        <!-- <div style="width:20%">
                          <v-btn color="primary" elevation="0"  dark class="ml-2"
                            @click="searchLocationAndAddMarker()">
                            <v-icon left>mdi-magnify</v-icon>ค้นหา
                          </v-btn>
                        </div> -->
                      </div>
                    </l-control>
                  </l-map>
                </div>
                <!-- <GmapAutocomplete
                  class="mb-3"
                  :style="'width:900px;max-width:100% !important;'"
                  :placeholder="'ค้นหาสถานที่'"
                  @place_changed="geolocateStart"
                  v-on:change="doClearLocation"
                  :options="{ fields: ['geometry'] }"
                ></GmapAutocomplete>
                <GmapMap
                  ref="mapRef"
                  :center="center"
                  :zoom="zoom"
                  map-type-id="terrain"
                  style="width: 100%; height: 300px"
                  @click="addMarker"
                  :options="mapStyle"
                >
                  <GmapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m"
                    :clickable="true"
                    :draggable="true"
                    @click="removeMarker(index)"
                  />
                </GmapMap> -->
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-container>
    </v-container>
  </div>
</template>
<script>

import menuBar from "../../components/menuBar";
import FileUpload from "../../components/FileUpload";
import DocFileUpload from "../../components/DocumentFileUpload";
import Day from "../../components/Day";
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";
//AIzaSyAEVBQEOGBCGSmB_UrhGaAUPbtywC0s1TE   (google map key)
//sk.eyJ1Ijoic29vbnRvcm4yNiIsImEiOiJja2VtYzhzcGkxYjVtMnlwaXR3OWR0eDdjIn0.bOa1yFaYOOFLvHphcTpL6A
export default {
  components: {
    menuBar,
    FileUpload,
    Day,
    DocFileUpload,
  },

  data() {
    return {
      url: 'https://api.maptiler.com/maps/openstreetmap/{z}/{x}/{y}.jpg?key=ODQYjrfwMX2CleHUV2jQ',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 3,
      center: [47.413220, -1.219482],
      markerLatLng: [18.787773664847744, 98.98561477661133],
      bounds: null,
      mapStyle: {
        styles: [
          {
            featureType: "poi",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi.business",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
        ],
      },
      hosptype: [
        "โรงพยาบาลชุมชน",
        "โรงพยาบาลทั่วไป",
        "โรงพยาบาลศูนย์",
        "โรงพยาบาลส่งเสริมสุขภาพตำบล",
        "โรงพยาบาลเอกชน",
        "คลินิกสัตวแพทย์",
        "คลินิกเวชกรรม",
        "คลินิกทัวไป",
        "แล๊ป",
        "สหคลินิก",
        "คลินิกทันตกรรม",
        "สถานพักฟื้น",
        "อื่นๆ",
      ],
      branch: ["สำนักงานใหญ่", "สาขา"],
      lazy: false,
      showMenu: false,
      ru_c_type: [(v) => !!v || "กรุณาเลือกประเภทผู้ติดต่อ"],
      ru_c_group: [(v) => !!v || "กรุณาเลือกกลุ่มลูกค้า"],
      ru_c_organize_name: [(v) => !!v || "กรุณากรอกชื่อสถานพยาบาล/บริษัท"],
      ru_c_place_name: [(v) => !!v || "กรุณากรอกชื่อสถานที่รับบริการ"],
      ru_c_branch: [(v) => !!v || "กรุณาเลือกสำนักงาน/สาขาใหญ่"],
      ru_c_taxid: [(v) => !!v || "กรุณากรอกเลขประจำตัวผู้เสียภาษี"],
      ru_c_owner: [(v) => !!v || "กรุณากรอกผู้มีอำนาจรับผิดชอบ"],
      ru_c_address: [(v) => !!v || "กรุณากรอกที่อยู่"],
      ru_c_tele: [(v) => !!v || "กรุณากรอกเบอร์โทรศัพท์"],
      ru_c_email: [(v) => !!v || "กรุณากรอกอีเมลล์"],
      //test map leaftlet
      zoom: 14,
      center: { lat: 18.78726, lng: 98.98641 },
      //Service Product type
      PayserviceType: ["รายเดือน", "รายปี", "เหมาเป็นกิโล"],
      ServiceProduct_Price: [],
      ServiceProduct_weight: [],
      //Service Product type
      theLocation: "",
      curPlace: "",
      checkTSH: false,
      Cstatus: ["รอเสนอราคา", "ดำเนินการแล้ว", "ยกเลิก"],
      typeTax: ["นิติบุคคล", "บุคคลธรรมดา"],
      //time

      modal: false,
      dialog: false,
      serviceB: false,
      serviceA: "รพ.ใหญ่",
      carGo: false,
      data_Products: [],
      data_ProductA: [
        "โรงพยาบาลรัฐ",
        "โรงพยาบาลเอกชน",
        "รพ.สต.",
        "แลป",
        "เวชกรรมความงาม",
        "เวชกรรมทั่วไป.",
        "ทันตกรรม",
        "สัตวแพทย์",
        "อื่น ๆ",
      ],
      groupHosp: ["รพ.ใหญ่", "รพ.เล็ก"],
      servicePublic: "",
      data_servicePublic: ["โรงพยาบาลรัฐบาล", "โรงพยาบาลเอกชน"],
      serviceOther: "",
      GetcarGo: false,
      countRow: 1,
      isEdit: false,
      offices: ["สำนักงานใหญ่", "สาขา"],
      get_Office: false,
      dataCar: [],
      se_vat3: ["3%", "5%", "0.5%", "0.75%", "1%"],
      se_vat7: ["7%", "10%"],
      isVat3: false,
      isVat7: false,
      //data input to database
      markers: [],
      date: new Date().toISOString().substr(0, 10),
      CUSTOMER_NOTE: "",
      searchLocations: [],
      textsearch: null
    };
  },
  computed: {
    ...mapGetters({
      getDays: "CustomerDetail/GET_DAYS",
      getCustomer: "CustomerDetail/GET_CUSTOMER",
    }),
    CONTACT_TYPE: {
      get() {
        return this.getCustomer.CONTACT_TYPE;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CONTACT_TYPE",
          value: value,
        });
      },
    },
    CUSTOMER_NAME: {
      get() {
        return this.getCustomer.CUSTOMER_NAME;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_NAME",
          value: value,
        });
      },
    },
    CUSTOMER_BRANCH_NAME: {
      get() {
        return this.getCustomer.CUSTOMER_BRANCH_NAME;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_BRANCH_NAME",
          value: value,
        });
      },
    },
    CUSTOMER_TYPE: {
      get() {
        return this.getCustomer.CUSTOMER_TYPE;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_TYPE",
          value: value,
        });
      },
    },
    CUSTOMER_TYPE_OTHER: {
      get() {
        return this.getCustomer.CUSTOMER_TYPE_OTHER;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_TYPE_OTHER",
          value: value,
        });
      },
    },
    CUSTOMER_GROUP: {
      get() {
        return this.getCustomer.CUSTOMER_GROUP;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_GROUP",
          value: value,
        });
      },
    },
    CUSTOMER_BRANCH: {
      get() {
        return this.getCustomer.CUSTOMER_BRANCH;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_BRANCH",
          value: value,
        });
      },
    },
    ORGANIZATION_NAME: {
      get() {
        return this.getCustomer.ORGANIZATION_NAME;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "ORGANIZATION_NAME",
          value: value,
        });
      },
    },
    CUSTOMER_ADDRESS: {
      get() {
        return this.getCustomer.CUSTOMER_ADDRESS;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_ADDRESS",
          value: value,
        });
      },
    },
    CUSTOMER_SUBDISTRICT: {
      get() {
        return this.getCustomer.CUSTOMER_SUBDISTRICT;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_SUBDISTRICT",
          value: value,
        });
      },
    },
    CUSTOMER_DISTRICT: {
      get() {
        return this.getCustomer.CUSTOMER_DISTRICT;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_DISTRICT",
          value: value,
        });
      },
    },
    CUSTOMER_PROVINCE: {
      get() {
        return this.getCustomer.CUSTOMER_PROVINCE;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_PROVINCE",
          value: value,
        });
      },
    },
    CUSTOMER_ZIPCODE: {
      get() {
        return this.getCustomer.CUSTOMER_ZIPCODE;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_ZIPCODE",
          value: value,
        });
      },
    },
    PROVIDER_NAME: {
      get() {
        return this.getCustomer.PROVIDER_NAME;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "PROVIDER_NAME",
          value: value,
        });
      },
    },
    PROVIDER_POSITION: {
      get() {
        return this.getCustomer.PROVIDER_POSITION;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "PROVIDER_POSITION",
          value: value,
        });
      },
    },
    CUSTOMER_TAX_ID: {
      get() {
        return this.getCustomer.CUSTOMER_TAX_ID;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "CUSTOMER_TAX_ID",
          value: value,
        });
      },
    },
    CUSTOMER_PHONE: {
      get() {
        return this.getCustomer.PROVIDER_PHONE;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "PROVIDER_PHONE",
          value: value,
        });
      },
    },
    PROVIDER_PHONE: {
      get() {
        return this.getCustomer.PROVIDER_NEWPHONE;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "PROVIDER_NEWPHONE",
          value: value,
        });
      },
    },
    PROVIDER_EMAIL: {
      get() {
        return this.getCustomer.PROVIDER_EMAIL;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "PROVIDER_EMAIL",
          value: value,
        });
      },
    },
    PROVIDER_LINE_ID: {
      get() {
        return this.getCustomer.PROVIDER_LINE_ID;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "PROVIDER_LINE_ID",
          value: value,
        });
      },
    },
    PROVIDER_FACEBOOK: {
      get() {
        return this.getCustomer.PROVIDER_FACEBOOK;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "PROVIDER_FACEBOOK",
          value: value,
        });
      },
    },
    LINE_USERID: {
      get() {
        return this.getCustomer.LINE_USERID;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "LINE_USERID",
          value: value,
        });
      },
    },
    vat7: {
      get() {
        return this.getCustomer.ISVAT;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "ISVAT",
          value: value,
        });
      },
    },
    vat3: {
      get() {
        return this.getCustomer.ISVAT2;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "ISVAT2",
          value: value,
        });
      },
    },
    vat3_value: {
      get() {
        return this.getCustomer.VAT_VALUE2;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "VAT_VALUE2",
          value: value,
        });
      },
    },
    vat7_value: {
      get() {
        return this.getCustomer.VAT_VALUE;
      },
      set(value) {
        this.$store.commit("CustomerDetail/SET_ELEMENT", {
          key: "VAT_VALUE",
          value: value,
        });
      },
    },
  },
  watch: {},
  beforeCreate() { },
  mounted() {
    this.initLocation()
  },
  created() {
    if (this.$route.name == "register-newCustomer") {
      this.showMenu = true;
    } else {
      this.showMenu = false;
    }

  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    initLocation() {

      const success = (position) => {
        const latitude = position.coords.latitude
        const longitude = position.coords.longitude
        this.center = [latitude, longitude]
        this.markerLatLng = [latitude, longitude]
      }
      const error = (err) => {
        e.log(error)
      }
      navigator.geolocation.getCurrentPosition(success, error)

    },
    cancel() {
      if (this.$store.getters["CustomerDetail/IS_EDIT"] == "Admin") {
        window.location.href = `${this.$global_link}/newCustomer/all-newCustomer`;
      } else {
        window.location.href = `${this.$global_link}`;
      }
    },

    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    removeMarker(index) {
      this.markers.splice(index, 1);
    },
    addMarker(event) {
      let pos = event.latlng
      let position = {
        lat: pos.lat,
        lng: pos.lng,
      };
      this.markerLatLng = [pos.lat, pos.lng]
      let ml = this.markers.length;
      // console.log(ml);
      if (ml >= 0 && ml < 1) {
        this.markers.push(position);
      } else {
        this.markers = [];
        this.markers.push(position);
      }

    },
    searchLocationAndAddMarker(evt) {
      // Encode ชื่อสถานที่เพื่อให้เหมาะสมกับ URL
      let searchtxt = this.textsearch
      let searchobj = typeof evt == 'string' ? {} : evt
      let encodedLocationName = ""
      if (typeof searchtxt == 'string') {
        encodedLocationName = encodeURIComponent(searchtxt);
      }
      axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodedLocationName}`)
        .then(response => {
          const data = response.data;
          if (data.length > 0) {

            this.searchLocations = data

          } else {
            this.searchLocations = []
          }
        })
        .catch(error => console.log(error));
      if (searchobj.hasOwnProperty('lat')) {

        this.center = [searchobj.lat, searchobj.lon]
        this.markerLatLng = [searchobj.lat, searchobj.lon]
        let position = {
          lat: parseFloat(searchobj.lat),
          lng: parseFloat(searchobj.lon),
        };
        let ml = this.markers.length;
        // console.log(ml);
        if (ml >= 0 && ml < 1) {
          this.markers.push(position);
        } else {
          this.markers = [];
          this.markers.push(position);
        }

      }
    },
    doClearLocation() {
      this.theLocation = "";
      this.curPlace = "";
    },
    geolocateStart(event) {
      let laglng = event.geometry.location;
      let position = {
        lat: laglng.lat(),
        lng: laglng.lng(),
      };
      this.$refs.mapRef.$mapPromise.then((map) => {
        map.panTo(position);
      });
      // this.markers.push(position);
      let ml = this.markers.length;
      //console.log(ml);
      if (ml >= 0 && ml < 1) {
        this.markers.push(position);
      } else {
        this.markers = [];
        this.markers.push(position);
      }
      // console.log(event.geometry.location)
    },
    Setgroup(e) {
      if (e == "รพ.ใหญ่") {
        this.serviceA = e;
      } else if (e == "รพ.เล็ก") {
        this.serviceA = e;
      }
    },
    SetpublicHosp(e) {
      if (e == "รพ.เล็ก") {
        this.servicePublic = e;
      } else if (e == "อื่น ๆ") {
        this.servicePublic = e;
      } else {
        this.servicePublic = "";
      }
    },
    SetOther(e) {
      if (e == "อื่น ๆ") {
        this.serviceOther = e;
      } else {
        this.serviceOther = "";
      }
    },
    set_Office(e) {
      if (e == "สาขา") {
        this.get_Office = true;
      } else {
        this.get_Office = false;
      }
    },
    SetcarGo(e) {
      this.GetcarGo = e;
    },
    countaddRow() {
      this.countRow++;
    },
    countsubRow() {
      if (this.countRow > 1) this.countRow--;
    },
    //insert database
    checked_vat7(item) {
      this.isVat7 = item;
    },
    checked_vat3(item) {
      this.isVat3 = item;
    },
    resetform() {
      this.markers = [];
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$store.dispatch("CustomerDetail/reset");
      this.$store.dispatch("CustomerDetail/initDays");
    },
    check_day() {
      let x = this.getDays;
      for (const key in x) {
        if (Object.hasOwnProperty.call(x, key)) {
          if (
            x[key].ISOPEN == true &&
            // x[key].HOURS_END.includes("HH") == false  && 
            // x[key].HOURS_END.includes("mm") == false && 
            x[key].HOURS_START.includes("HH") == false &&
            x[key].HOURS_START.includes("mm") == false
          ) {

            //console.log('true');
            return true;
          } else {
            //console.log('false');

          }
        }
      }
    },
    async add_customer() {
      //this.LOADER(true);
      let insertCustomer = this.getCustomer;
      let latlng = this.markers;
      let subdis = this.CUSTOMER_SUBDISTRICT;
      let dis = this.CUSTOMER_DISTRICT;
      let pro = this.CUSTOMER_PROVINCE;
      let zipcode = this.CUSTOMER_ZIPCODE;

      if (latlng.length == 0) {
        this.LOADER(false);
        this.$swal(
          "เกิดข้อผิดพลาด",
          "กรุณากรอกพิกัดบริษัท / สถานบริการ",
          "warning"
        );
      } else if (!subdis && !dis && !pro && !zipcode) {
        this.LOADER(false);
        this.$swal(
          "เกิดข้อผิดพลาด",
          "กรุณาเลือกตำบล อำเภอ จังหวัด รหัสไปรษณีย์",
          "warning"
        );
      } else if (!this.$refs.form.validate()) {
        this.LOADER(false);
        this.$swal("เกิดข้อผิดพลาด", "กรุณากรอกข้อมูลให้ครบถ้วน", "warning");
      } else if (this.check_day() != true) {
        this.LOADER(false);
        this.$swal(
          "เกิดข้อผิดพลาด",
          "กรุณากรอกข้อมูลวันเวลาให้ครบถ้วน",
          "warning"
        );
      } else {
        insertCustomer.LATS = this.markers[0].lat;
        insertCustomer.LONGS = this.markers[0].lng;
        console.log('%c  getDays', 'color:DeepPink');
        console.log(this.getDays);
        //  this.$swal("สำเร็จ", "บันทึกเรียบร้อย", "success");
        //insert-customer-day
        this.$guest_api
          .post("/insert-customer", insertCustomer)
          .then(async (response) => {

            let cus_id = response.data.data.insertId;
            await this.$refs.Use_Method_FileUpload.onUpload(cus_id);
            await this.$refs.Use_Method_FileUpload_Document.onUpload(cus_id);
            this.$guest_api
              .post("/insert-customer-day", {
                CUSTOMER_ID: cus_id,
                PACKAGE: this.getDays,
              })

              .catch((error) => {
                console.log(error);
                this.LOADER(false);
                this.$swal("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
              })
              .finally((res) => {
                this.$swal("สำเร็จ", "บันทึกเรียบร้อย", "success");

                this.resetform();
                this.LOADER(false);
              });
            // this.$refs.Use_Method_FileUpload.onUpload();
          })
          .catch((error) => {
            console.log(error);
            this.LOADER(false);
            this.$swal("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
          })
          .finally((res) => { });
      }
    },
  },
};
</script>
